import React, { useEffect, useState } from "react";
import { Navbar } from "react-bootstrap";
import { Helmet } from 'react-helmet';
import { HiArrowLeft } from 'react-icons/hi';
import { useNavigate } from "react-router-dom";
import Header from '../../Layout/Header';
import TableCustomer from "./TableCustomer";
import SidebarMenu from "../../Layout/SidebarMenu";
import ListCustomer from "./ListCustomer";
import { useMediaQuery } from 'react-responsive';

const Customer = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const isTabletOrLaptop = useMediaQuery({ query: '(min-width: 600px)' });

    const [sidebarVisible, setSidebarVisible] = useState(false);

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const navigate = useNavigate();

    useEffect(() => {

    }, []);

    return (
        <>
            <Helmet>
                <title>Data Pelanggan</title>
            </Helmet>
            <div className="d-block d-sm-none">
                <Navbar expand="lg" className="mainNavbar border-bottom mb-3" sticky="top">
                    <a href="#" onClick={() => navigate(-1)} className="navBackMenu">
                        <HiArrowLeft />
                    </a>
                    <strong className="me-auto navTitle">Data Pelanggan</strong>
                    <Navbar.Toggle className="d-block d-sm-none me-3" onClick={(e) => setSidebarVisible(true)} />
                </Navbar>
                {isMobile && <ListCustomer />}
            </div>
            <div className="d-none d-sm-inline">
                <Header />
                {isTabletOrLaptop && <TableCustomer />}
            </div>
            <SidebarMenu show={sidebarVisible} close={(e) => setSidebarVisible(false)} />
        </>
    );
}

export default Customer;
